import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <div className="logo-text">
            <span className="logo-main">GARDEN POÈTE</span>
            <span className="logo-sub">Since 2019</span>
          </div>
        </Link>

        <button className="navbar-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={menuOpen ? 'navbar-menu active' : 'navbar-menu'}>
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/venue" onClick={closeMenu}>Venue</Link>
          </li>
          <li>
            <Link to="/catering" onClick={closeMenu}>Catering</Link>
          </li>
          <li>
            <Link to="/flower" onClick={closeMenu}>Flower</Link>
          </li>
          <li>
            <Link to="/your-wedding" onClick={closeMenu}>Pricing</Link>
            </li>
            <li>
              <Link to="/reservation" onClick={closeMenu}>Reservation</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
